export const getYouTubeVideoId = source => {
    try {
        const url = new URL(source);
        if (!['http:', 'https:'].includes(url.protocol)) return null;
        const host = url.hostname.toLowerCase();
        let id;
        if (host === 'youtu.be') {
            id = url.pathname.split('/')[1];
        } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
            id = url.searchParams.get('v');
            if (!id && /^\/(embed|shorts|live)\//.test(url.pathname)) id = url.pathname.split('/')[2];
        }
        return /^[a-zA-Z0-9_-]{11}$/.test(id || '') ? id : null;
    } catch {
        return null;
    }
};
